module.exports = __webpack_public_path__ + "static/media/Duck.5d360ee5.png";